import { render, staticRenderFns } from "./FileRouter.vue?vue&type=template&id=90308d76&scoped=true&"
import script from "./FileRouter.vue?vue&type=script&lang=ts&"
export * from "./FileRouter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90308d76",
  null
  
)

export default component.exports